module.exports = __webpack_public_path__ + "img/forest-moon.79718d8d.svg";